import React from 'react';

const DocumentHistoryDayHeader = ({ dayLabel }) => (
  <div className="p-3 bg-flexi-bg-day-timeline">
    <span className="text-base font-bold">
      {dayLabel}
    </span>
  </div>
);

export default DocumentHistoryDayHeader;
